var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHackathon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.1,48.2H19.9v-6.7l-3.4-1.1L12,44.8L5.2,38l4.5-4.5l-1.1-3.4H1.8V19.9h6.7l1.1-3.4L5.2,12L12,5.2l4.5,4.5l3.4-1.1V1.8 h10.1v6.7l3.4,1.1L38,5.2l6.8,6.8l-4.5,4.5l1.1,3.4h6.7v10.1h-6.7l-1.1,3.4l4.5,4.5L38,44.8l-4.5-4.5l-3.4,1.1V48.2z M21.4,46.7 h7.2v-6.3l5.3-1.8l4.1,4.1l4.8-4.8l-4.1-4.1l1.8-5.3h6.3v-7.2h-6.3l-1.8-5.3l4.1-4.1L38,7.2l-4.1,4.1l-5.3-1.8V3.3h-7.2v6.3 l-5.3,1.8L12,7.2L7.2,12l4.1,4.1l-1.8,5.3H3.3v7.2h6.3l1.8,5.3L7.2,38l4.8,4.8l4.1-4.1l5.3,1.8V46.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,30.1c-2.8,0-5.1-2.3-5.1-5.1c0-2.8,2.3-5.1,5.1-5.1c2.8,0,5.1,2.3,5.1,5.1C30.1,27.8,27.8,30.1,25,30.1z M25,21.4 c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6c2,0,3.6-1.6,3.6-3.6C28.6,23,27,21.4,25,21.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHackathon);
export default __webpack_public_path__ + "static/media/hackathon.236c67c9fb6a69fa61d07b09628e7a9b.svg";
export { ForwardRef as ReactComponent };